import { Button } from '@campgladiator/cgui-core.atoms.button'
import { Icon } from '@campgladiator/cgui-core.atoms.icon'
import { Paragraph } from '@campgladiator/cgui-core.atoms.typography'
import { CardPartProps } from '../../../../../../../pages/OnDemandWorkouts/OnDemandWorkouts.d'
import { Tags } from '../../../Tags'
import baseStyles from '../../BottomPartCard.module.scss'
import { visibleTags } from '../../logic'
import useVirtual from './useVirtual'
import styles from './Virtual.module.scss'
import { WorkoutTime } from './WorkoutTime'

const Virtual = ({
  workout,
  isLoggedIn,
  hasJoinedWorkout = false,
  onJoinLiveClick = () => {},
  onLoginClick,
  token = {
    refreshToken: '',
    token: '',
    type: '',
  },
  user = {},
  onCheckInClick,
  isCheckinLoading,
  checkedInWorkout,
  checkinError,
  onAutomaticCheckIn,
}: CardPartProps) => {
  const {
    workoutLinkIfIsLive,
    onWorkoutClick,
    targetBasedOnIsWorkoutLive,
    workoutStartHour,
    isLive,
    userLoggedInWithVirtualAccess,
    handleCheckinClick,
    hasCheckedIn,
    checkInButtonText,
    joinLiveButtonText,
    userLoggedInWithNoVirtualAccess,
    handleRegisterClick,
    workoutStartDate,
    handleJoinLiveClick,
    showManualCheckIn,
    canCheckIn,
    isAddedToCalendar,
    handleAddToCalendarClick,
    hasMobileAppAccess,
    isAddingToCalendar,
  } = useVirtual({
    user,
    hasJoinedWorkout,
    isCheckinLoading,
    checkedInWorkout,
    isLoggedIn,
    token,
    workout,
    onCheckInClick,
    onJoinLiveClick,
    checkinError,
    onAutomaticCheckIn,
  })

  return (
    <div className={baseStyles.bottomPart}>
      <div className={styles.topRowContainer}>
        <Paragraph className={baseStyles.workoutTitle}>
          <a
            className={baseStyles.textLink}
            href={workoutLinkIfIsLive}
            onClick={onWorkoutClick}
            target={targetBasedOnIsWorkoutLive}
            rel="noreferrer"
          >
            {workoutStartHour}
          </a>
        </Paragraph>

        {userLoggedInWithVirtualAccess && (
          <button
            type="button"
            className={styles.calendarButton}
            onClick={handleAddToCalendarClick}
            aria-label={
              hasMobileAppAccess && isAddedToCalendar
                ? 'Workout added to calendar'
                : 'Add workout to calendar'
            }
          >
            {hasMobileAppAccess && isAddingToCalendar ? (
              <span className={styles.calendarLoading} />
            ) : hasMobileAppAccess && isAddedToCalendar ? (
              <div className={styles.calendarSuccess}>
                <Icon.Line name="icon-check" />
              </div>
            ) : (
              <Icon.Line name="icon-calendar-alt" />
            )}
          </button>
        )}
      </div>
      {isLive && (
        <div className={baseStyles.actions}>
          {userLoggedInWithVirtualAccess ? (
            <>
              {showManualCheckIn && (
                <Button
                  emphasis="primary"
                  variation="outline"
                  size="small"
                  onClick={handleCheckinClick}
                  disabled={isCheckinLoading || hasCheckedIn || !canCheckIn}
                >
                  {checkInButtonText}
                </Button>
              )}
              <Button
                emphasis="primary"
                size="small"
                onClick={handleJoinLiveClick}
                disabled={!canCheckIn}
              >
                {joinLiveButtonText}
              </Button>
            </>
          ) : userLoggedInWithNoVirtualAccess ? (
            <Button
              emphasis="secondary"
              size="small"
              onClick={handleRegisterClick}
            >
              Register to Join
            </Button>
          ) : (
            <Button emphasis="secondary" size="small" onClick={onLoginClick}>
              Login to Join
            </Button>
          )}
        </div>
      )}
      {visibleTags.length > 0 && <Tags items={visibleTags(workout)} />}
      {!isLive && (
        <Paragraph
          size="xsmall"
          weight="book"
          className={styles.workoutAvailiability}
        >
          <WorkoutTime workoutStartDate={workoutStartDate} />
        </Paragraph>
      )}
    </div>
  )
}

export default Virtual
